import { CSSProperties, ReactElement } from 'react';
import { FieldHeaderComponent, LinkFieldComponent } from '@vivli/shared/components';
import { Size, Styles } from '@vivli/shared/theme';
import { StudiesProvidedComponent } from './studies-provided.component';
import { AssetsConstant } from '@vivli/shared/infrastructure/constants';

const containerStyle: CSSProperties = {
    width: '100%',
    height: '100%',
    position: 'relative',
    overflow: 'hidden',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
};

const innerStyle: CSSProperties = {
    ...Styles.CENTERED_IN_BLOCK,
    textAlign: 'center',
};

const fieldHeaderStyle: CSSProperties = {
    fontSize: Size.FontSize.Larger,
    fontWeight: Size.FontWeight.Bold,
    justifyContent: 'space-around',
};

const imgStyle: CSSProperties = {
    marginBottom: '20px',
};

const imgStyleLongMessage: CSSProperties = {
    marginBottom: '60px',
};

const linkStyle: CSSProperties = {
    backgroundColor: 'none',
    boxShadow: 'none',
    borderBottom: 'none',
    flexDirection: 'row',
    fontSize: '16px',
    paddingTop: '10px',
    marginTop: '25px',
};

interface BlockMessageComponent {
    children?: ReactElement;
    url?: any;
    message: any;
    showProvidedStudies?: boolean;
}

export const BlockMessageComponent = ({ children, url, message, showProvidedStudies }: BlockMessageComponent) => {
    const warningStyleToUse = message.length <= 70 ? imgStyle : imgStyleLongMessage;
    const fieldHeaderStyleToUse = message.length <= 100 ? fieldHeaderStyle : { ...fieldHeaderStyle, fontSize: Size.FontSize.Large };

    return (
        <div style={containerStyle}>
            <div style={innerStyle}>
                {showProvidedStudies && <StudiesProvidedComponent />}

                <div style={warningStyleToUse}>
                    <img src={AssetsConstant.SIGN_WARNING} />
                </div>

                <FieldHeaderComponent style={fieldHeaderStyleToUse} title={message} />
                {url && <LinkFieldComponent label={''} linkContent={url} linkTitle={url} style={linkStyle} />}

                {children}
            </div>
        </div>
    );
};
